import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28fe4e46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "board_title space-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_title" }, " 토론 NOW ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray main_14R" }, "모아보기", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn",
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}, null, -1))
const _hoisted_6 = { class: "board_wrap" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "board_tail",
  src: "/assets/icon/board_tail.png",
  srcset: "/assets/icon/board_tail@2x.png 2x,/assets/icon/board_tail@3x.png 3x"
}, null, -1))
const _hoisted_9 = { class: "board_list" }
const _hoisted_10 = { class: "logo-title" }
const _hoisted_11 = { class: "title_14B" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "leaf",
  src: "/assets/icon/small_leaf_g.png"
}, null, -1))
const _hoisted_13 = { class: "green main_12R" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "ion-activatable ripple-parent title_right",
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'토론 NOW', 'clickContent':'모아보기'});_ctx.router.push('/tabs/community')})
      }, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemBoards, (board) => {
        return (_openBlock(), _createElementBlock("div", {
          key: board.partnershipBoardId,
          class: "content_wrap",
          onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'토론 NOW', 'clickContent':`${board.stockItemName}/${board.contents?.substring(0,50)}`});_ctx.router.push('/tabs/community')}
        }, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(board.stockItemName), 1),
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.toFixed(+board.avgPoint, 1)), 1)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["board_content", {gray:(board.status!='show')}]),
              onClick: ($event: any) => (_ctx.boardClick(board,$event))
            }, _toDisplayString(board.contents), 11, _hoisted_14)
          ])
        ], 8, _hoisted_7))
      }), 128))
    ])
  ]))
}